import { Collapse, ListItem, ListItemText, ListItemIcon, ListItemButton, Grid } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React from "react";
import TransactionLine from "./TransactionLine";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default class HistMonthPanel extends React.Component {
    state = {
        collapseOpened:true,
        contextIndex:-1,
        menuX:0, menuY:0
    }
    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    constructor(props) {
        super(props)
        this.render = this.render.bind(this)
        this.contextHandler = this.contextHandler.bind(this)
    }

    contextHandler(event, index) {
        console.log("Context menu on event=", event, " item ", index)
        this.setState({contextIndex:index, menuX:event.clientX+2, menuY:event.clientY+2})
        this.forceUpdate()
        console.log(this.state)
    }

    render() {
//        debugger;
        var trs = this.props.transactions
        if(trs.length==0) {
            return <div></div>
        };
        var month_trs = trs.filter(t => t.date.year() == this.props.year && t.date.month() == this.props.month)
        if(month_trs.length==0) {
            return <div></div>
        };

        var totalPlus = month_trs.filter(t => t.sum>0).map(t => t.sum).reduce((sum, a) => sum+parseInt(a), 0)
        var totalMinus = -month_trs.filter(t => t.sum<0).map(t => t.sum).reduce((sum, a) => sum+parseInt(a), 0)
        var total = totalPlus - totalMinus
        // console.log("year=", this.props.year, "month=", this.props.month, "total =", totalPlus,"-", totalMinus,"=", total)
        
        var monthTitle = 
            <ListItem>
                <ListItemButton
                    onClick={() => {
                        console.log("Open clicked")
                        this.setState({collapseOpened: !this.state.collapseOpened})
                    }
                }
                >
                    <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2}><ListItemText>
                            <b>{this.monthNames[this.props.month]} {this.props.year}</b>
                            </ListItemText></Grid>
                        <Grid item xs={1}><ListItemIcon>{this.state.collapseOpened ? <ExpandLess/>: <ExpandMore/>}</ListItemIcon></Grid>
                        <Grid item xs={3}/>
                        <Grid item xs={3}><ListItemText>Total=+{totalPlus}-{totalMinus}={total}</ListItemText></Grid>
                    </Grid>
                </ListItemButton>
                </ListItem>
            var monthPanel = 
                <Collapse in={this.state.collapseOpened}>
                {trs.map((info, index) => [info, index]).filter( 
                    info_index => info_index[0].date.year() == this.props.year && info_index[0].date.month() == this.props.month
                    ).map( info_index => 
                    <TransactionLine
                        key={info_index[1]} index={info_index[1]} info={info_index[0]} 
                        deleteHandle={this.props.deleteHandle} copyHandle = {this.props.copyHandle} 
                        updateHandle={this.props.updateHandle}
                        contextHandler = {this.contextHandler}
                    />
                    
                    )}
                </Collapse>
                
            var menu = <Menu 
                open= {this.state.contextIndex>=0}
                onClose={() => {
                    this.setState({contextIndex:-1})
                }}
                anchorReference="anchorPosition"
                anchorPosition={{top:this.state.menuX, left:this.state.menuY}}
                >
                    <MenuItem onClick={() => {
                        this.props.deleteHandle(this.state.contextIndex)
                        this.setState({contextIndex:-1})
                        }}>Delete</MenuItem>
                    <MenuItem onClick={() => {
                        this.props.copyHandle(this.state.contextIndex)
                        this.setState({contextIndex:-1})
                        }}>Copy to next month</MenuItem>
                    <MenuItem onClick={() => {
                        this.props.addTransToFavsHandle(this.state.contextIndex)
                        this.setState({contextIndex:-1})
                        }}>Add to favorites</MenuItem>

                </Menu>


        return(
            <div>
                {monthTitle}
                {monthPanel}
                {menu}
            </div>
        )
    }
}